{
  "headingLocationSpecific": "Finde top bewertete Immobilienagenturen in {location}",
  "seo.pageDescriptionLocationSpecific": "Entdecke die Top-Immobilienagenturen in {location}. Finde Experten in deiner Nähe für den Kauf oder Verkauf deiner Immobilie.",
  "seo.pageTitleLocationSpecific": "Top-Immobilienagenturen für Kauf- und Mietobjekte in {location} {'|'} Homegate",
  "seo.pageTitleWithPageLocationSpecific": "Seite {page} - Bestbewertete Immobilienagenturen in {location} finden | Homegate"
}